<template>
	<quote-modal 
		:tray-image-url="trayImageUrl" 
		:tray-name="selectedTrayName" 
		:tray-size="selectedTraySize" 
		:product-code="productCode" 
		v-if="showQuoteModal" 
		@close="showQuoteModal = false">
	</quote-modal>
	<email-modal :tray-image-url="trayImageUrl" v-if="showEmailModal" @close="showEmailModal = false"></email-modal>
	<div class="personal camtread">
		<div class="header">
			<a href="javascript:history.back()" class="left-arrow">
				<img src="images/left.svg" />
			</a>
			<h1>Camtread Tray</h1>
		</div>
		<div class="personal-left" ref="trayContainer">
			<div id="tray-container">
				<transition name="fade" mode="out-in">
					<img :src="selectedTrayImage" :key="selectedTrayImage" width="100%" />
				</transition>
				<div v-if="uploadedImage" class="uploaded-image">
					<img :src="uploadedImage" alt="Uploaded Image" ref="targetElement" />
				</div>
				<moveable
					v-if="targetElement"
					:target="targetElement"
					:draggable="true"
					:resizable="{ keepRatio: true }"
					:scalable="true"
					:rotatable="true"
					@drag="handleDrag"
					@resize="handleResize"
					@scale="handleScale"
					@rotate="handleRotate"
				/>
			</div>
			<div class="coach">Click uploaded image to move it. Hold and drag corners to resize.</div>
		</div>
		<div class="personal-right">
			<h4>Select a Color</h4> <h5>{{ selectedTrayName }}</h5>
			<div class="select-color">
				<a href="javascript:void(0)" class="Black110 active" @click="setActive($event, 'Black110')"></a>
			</div>

			<h4>Add a Photo</h4>
			<input type="file" @change="onFileChange" ref="fileInput" />
			  <button @click="resetUpload" class="btn-reset">Remove Image</button>
			<div class="cleaner"></div>
			<h4>Select a Size</h4>
			<div class="select-size">
				<select name="size" id="select-dropdown" v-model="selectedSizeCode" @change="selectSize">
					<option value="1600CT">16" (40,5 cm)</option>
				</select>
			</div>
			<div>
				<h4>Your Tray Details</h4>
				<h5>Color: <strong>{{ selectedTrayName }}</strong></h5>
				<h5>Tray Size: <strong>{{ selectedTraySize }}</strong></h5>
				<h5>Product Code: <strong>{{ productCode }}</strong></h5>
			</div>
			<button @click="captureScreenshot(false)" class="btn-quote">Request a Free Sample and Quote</button>
			<button @click="downloadImage" class="btn-download">Download</button>
			<button @click="captureScreenshot(true)" class="btn-email">Email My Tray</button>
		</div>
	</div>
</template>
  
<script>
import * as htmlToImage from 'html-to-image';
import QuoteModal from './Quote.vue';
import EmailModal from './EmailForm.vue';
import '../assets/round.css';
import { ref, onMounted, onUnmounted, watch } from 'vue';
import Moveable from "vue3-moveable";

export default {
	components: {
		QuoteModal,
		EmailModal,
		Moveable
	},
	setup() {
		const targetElement = ref(null);
		const isMoveableActive = ref(false);
		const activeTarget = ref(null);

		const handleClickOutside = (event) => {
			if (!event.target.closest('#tray-container') && isMoveableActive.value) {
				activeTarget.value = null;
				isMoveableActive.value = false;
			}
		};

		onMounted(() => {
			document.addEventListener('mousedown', handleClickOutside);
		});

		onUnmounted(() => {
			document.removeEventListener('mousedown', handleClickOutside);
		});

		watch(isMoveableActive, (newValue) => {
			if (newValue) {
				activeTarget.value = targetElement.value;
			} else {
				activeTarget.value = null;
			}
		});

		const handleDrag = ({ beforeTranslate }) => {
			targetElement.value.style.transform = `translate(${beforeTranslate[0]}px, ${beforeTranslate[1]}px)`;
		};
		
		const handleResize = ({ target, width, height, delta }) => {
			target.style.width = `${width}px`;
			target.style.height = `${height}px`;
		};
		
		const handleScale = ({ target, dist }) => {
			const scaleX = dist[0];
			const scaleY = dist[1];
			target.style.transform = `scale(${scaleX}, ${scaleY})`;
		};
		
		const handleRotate = ({ beforeRotate }) => {
			targetElement.value.style.transform = `rotate(${beforeRotate}deg)`;
		};

		return {
			targetElement,
			activeTarget,
			isMoveableActive,
			handleDrag,
			handleResize,
			handleScale,
			handleRotate,
		};
	},
	data() {
		return {
			showQuoteModal: false,
			showEmailModal: false,
			selectedTrayImage: 'images/round/camtread/Black-110.png',
			selectedColor: 'Black110',
			selectedTrayName: 'Black',
			selectedTraySize: '16" (40,5 cm)',
			selectedSizeCode: '1600CT',
			uploadedImage: null,
			trayImageUrl: null,
			colorToImageMap: {
				Black110: 'images/round/camtread/Black-110.png',
			},
		};
	},
	methods: {
		captureScreenshot(openEmailModal = false) {
			const node = this.$refs.trayContainer;
			htmlToImage.toPng(node, {
				filter: function (node) {
					return node.nodeType === Node.ELEMENT_NODE && !node.classList.contains('rCS1w3zcxh') && !node.classList.contains('coach');
				}
			})
			.then((dataUrl) => {
				this.trayImageUrl = dataUrl;
				if (openEmailModal) {
					this.showEmailModal = true;
					this.showQuoteModal = false;
				} else {
					this.showQuoteModal = true;
					this.showEmailModal = false;
				}
			})
			.catch((error) => {
				console.error('Failed to capture screenshot', error);
			});
		},

		resetUpload() {
			this.uploadedImage = null;
			this.$refs.fileInput.value = '';
		},

		setActive(event, color) {
			this.selectedColor = color;
			this.selectedTrayImage = this.colorToImageMap[color];
			this.selectedTrayName = this.formatTrayName(color);
			const swatches = document.querySelectorAll('.select-color a');
			swatches.forEach(sw => sw.classList.remove('active'));
			event.currentTarget.classList.add('active');
		},

		onFileChange(e) {
			const files = e.target.files;
			if (files.length > 0) {
				const fileReader = new FileReader();
				fileReader.readAsDataURL(files[0]);
				fileReader.onload = (e) => {
					this.uploadedImage = e.target.result;
				};
			}
		},

		formatTrayName(className) {
			return className
				.replace(/\d+/g, '')
				.replace(/([a-z])([A-Z])/g, '$1 $2')
				.trim()
				.split(' ')
				.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
				.join(' ');
		},

		selectSize(event) {
			this.selectedSizeCode = event.target.value;
			let selectedOption = event.target.options[event.target.selectedIndex];
			this.selectedTraySize = selectedOption ? selectedOption.text : '';
		},

		downloadImage() {
			const node = this.$refs.trayContainer;
			htmlToImage.toPng(node, {
				filter: function (node) {
					return node.nodeType === Node.ELEMENT_NODE && !node.classList.contains('rCS1w3zcxh') && !node.classList.contains('coach');
				}
			})
			.then((dataUrl) => {
				const link = document.createElement('a');
				link.href = dataUrl;
				link.download = 'My-Custom-Cambro-Tray.png';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			})
			.catch((error) => {
				console.error('Failed to download image', error);
			});
		},
	},
	computed: {
		selectedTrayName() {
			const colorName = this.formatTrayName(this.selectedColor);
			const colorCodeMatch = this.selectedColor.match(/(\d+)$/);
			const colorCode = colorCodeMatch ? colorCodeMatch[1] : '';
			return `${colorName} (${colorCode})`;
		},
		productCode() {
			let colorCodeMatch = this.selectedColor.match(/\d+$/);
			let colorCode = colorCodeMatch ? colorCodeMatch[0] : '';
			return `${this.selectedSizeCode}${colorCode}`;
		}
	},
};
</script>